import React from 'react'

export default function SectionHeading({number ,content, className}: {content: React.ReactNode, number:string; className?: string}) {
  return (
    <h3 className={`uppercase pb-10 flex items-center ${className || ''}`}>{number} <span className='h-0.5 w-12 bg-accent mx-4'></span> {content}</h3>
  )
}
